/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
import produce from "immer";
import {
  GET_ORDER_VERIFICATIONS_REQUEST,
  GET_ORDER_VERIFICATIONS_SUCCESS,
  GET_ORDER_VERIFICATIONS_FAILURE,
  GET_ORDER_VERIFICATIONS_FAILED_DELIVERY_REQUEST,
  GET_ORDER_VERIFICATIONS_FAILED_DELIVERY_SUCCESS,
  GET_ORDER_VERIFICATIONS_FAILED_DELIVERY_FAILURE,
  GET_ORDER_VERIFICATIONS_DUPLICATED_REQUEST,
  GET_ORDER_VERIFICATIONS_DUPLICATED_SUCCESS,
  GET_ORDER_VERIFICATIONS_DUPLICATED_FAILURE,
  GET_ORDER_VERIFICATIONS_HIGH_VALUE_REQUEST,
  GET_ORDER_VERIFICATIONS_HIGH_VALUE_SUCCESS,
  GET_ORDER_VERIFICATIONS_HIGH_VALUE_FAILURE,
  GET_ORDER_VERIFICATIONS_CUSTOMER_REQUEST,
  GET_ORDER_VERIFICATIONS_CUSTOMER_SUCCESS,
  GET_ORDER_VERIFICATIONS_CUSTOMER_FAILURE,
  GET_ONE_ORDER_VERIFICATION_REQUEST,
  GET_ONE_ORDER_VERIFICATION_SUCCESS,
  GET_ONE_ORDER_VERIFICATION_FAILURE,
  ADD_ORDER_VERIFICATION_FAILED_DELIVERY_REQUEST,
  ADD_ORDER_VERIFICATION_FAILED_DELIVERY_SUCCESS,
  ADD_ORDER_VERIFICATION_FAILED_DELIVERY_FAILURE,
  ADD_ORDER_VERIFICATION_DUPLICATED_REQUEST,
  ADD_ORDER_VERIFICATION_DUPLICATED_SUCCESS,
  ADD_ORDER_VERIFICATION_DUPLICATED_FAILURE,
  ADD_ORDER_VERIFICATION_HIGH_VALUE_REQUEST,
  ADD_ORDER_VERIFICATION_HIGH_VALUE_SUCCESS,
  ADD_ORDER_VERIFICATION_HIGH_VALUE_FAILURE,
  ADD_ORDER_VERIFICATION_CUSTOMER_REQUEST,
  ADD_ORDER_VERIFICATION_CUSTOMER_SUCCESS,
  ADD_ORDER_VERIFICATION_CUSTOMER_FAILURE,
  UPDATE_ORDER_VERIFICATION_REQUEST,
  UPDATE_ORDER_VERIFICATION_SUCCESS,
  UPDATE_ORDER_VERIFICATION_FAILURE,
  DELETE_ORDER_VERIFICATION_REQUEST,
  DELETE_ORDER_VERIFICATION_SUCCESS,
  DELETE_ORDER_VERIFICATION_FAILURE,
  DELETE_ORDER_VERIFICATION_DUPLICATED_REQUEST,
  DELETE_ORDER_VERIFICATION_DUPLICATED_SUCCESS,
  DELETE_ORDER_VERIFICATION_DUPLICATED_FAILURE,
  DELETE_ORDER_VERIFICATION_HIGH_VALUE_REQUEST,
  DELETE_ORDER_VERIFICATION_HIGH_VALUE_SUCCESS,
  DELETE_ORDER_VERIFICATION_HIGH_VALUE_FAILURE,
  CLEAR_ORDER_VERIFICATION
} from "src/actions/orderVerificationActions";

import map from "lodash/map";

const initialState = {
  orderVerifications: [],
  orderVerification: {},
  orderVerificationsFailedDelivery: [],
  orderVerificationsDuplicate: [],
  orderVerificationsHighValue: [],
  orderVerificationHighValue: [],
  orderVerificationsCustomer: [],
  loading: false
};

const orderVetificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ORDER_VERIFICATIONS_REQUEST: {
      return produce(state, (draft) => {
        draft.orderVerifications = [];
        draft.loading = true;
      });
    }

    case GET_ORDER_VERIFICATIONS_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.orderVerifications = response;
        draft.loading = false;
      });
    }

    case GET_ORDER_VERIFICATIONS_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_ORDER_VERIFICATIONS_FAILED_DELIVERY_REQUEST: {
      return produce(state, (draft) => {
        draft.orderVerificationsFailedDelivery = [];
        draft.loading = true;
      });
    }

    case GET_ORDER_VERIFICATIONS_FAILED_DELIVERY_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.orderVerificationsFailedDelivery = response;
        draft.loading = false;
      });
    }

    case GET_ORDER_VERIFICATIONS_FAILED_DELIVERY_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    case GET_ORDER_VERIFICATIONS_DUPLICATED_REQUEST: {
      return produce(state, (draft) => {
        draft.orderVerificationsDuplicate = [];
        draft.loading = true;
      });
    }

    case GET_ORDER_VERIFICATIONS_DUPLICATED_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.orderVerificationsDuplicate = response;
        draft.loading = false;
      });
    }

    case GET_ORDER_VERIFICATIONS_DUPLICATED_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    case GET_ORDER_VERIFICATIONS_HIGH_VALUE_REQUEST: {
      return produce(state, (draft) => {
        draft.orderVerificationHighValue = [];
        draft.loading = true;
      });
    }

    case GET_ORDER_VERIFICATIONS_HIGH_VALUE_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.orderVerificationHighValue = response;
        draft.loading = false;
      });
    }

    case GET_ORDER_VERIFICATIONS_HIGH_VALUE_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    case GET_ORDER_VERIFICATIONS_CUSTOMER_REQUEST: {
      return produce(state, (draft) => {
        // draft.orderVerificationsCustomer = [];
        draft.loading = true;
      });
    }

    case GET_ORDER_VERIFICATIONS_CUSTOMER_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.orderVerificationsCustomer = response;
        draft.loading = false;
      });
    }

    case GET_ORDER_VERIFICATIONS_CUSTOMER_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    case ADD_ORDER_VERIFICATION_FAILED_DELIVERY_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case ADD_ORDER_VERIFICATION_FAILED_DELIVERY_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.orderVerificationsFailedDelivery = [
          ...draft.orderVerificationsFailedDelivery,
          response
        ];
        draft.loading = false;
      });
    }

    case ADD_ORDER_VERIFICATION_FAILED_DELIVERY_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case ADD_ORDER_VERIFICATION_DUPLICATED_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case ADD_ORDER_VERIFICATION_DUPLICATED_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.orderVerificationsDuplicate = [
          ...draft.orderVerificationsDuplicate,
          response
        ];
        draft.loading = false;
      });
    }

    case ADD_ORDER_VERIFICATION_DUPLICATED_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case ADD_ORDER_VERIFICATION_HIGH_VALUE_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case ADD_ORDER_VERIFICATION_HIGH_VALUE_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.orderVerificationHighValue = [
          ...draft.orderVerificationHighValue,
          response
        ];
        draft.loading = false;
      });
    }

    case ADD_ORDER_VERIFICATION_HIGH_VALUE_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    case ADD_ORDER_VERIFICATION_CUSTOMER_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case ADD_ORDER_VERIFICATION_CUSTOMER_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.orderVerifications = [...draft.orderVerifications, response];
        draft.loading = false;
      });
    }

    case ADD_ORDER_VERIFICATION_CUSTOMER_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case GET_ONE_ORDER_VERIFICATION_REQUEST: {
      return produce(state, (draft) => {
        draft.orderVerification = {};
        draft.loading = true;
      });
    }

    case GET_ONE_ORDER_VERIFICATION_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.orderVerification = response;
        draft.loading = false;
      });
    }

    case GET_ONE_ORDER_VERIFICATION_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case UPDATE_ORDER_VERIFICATION_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case UPDATE_ORDER_VERIFICATION_SUCCESS: {
      const {response} = action.payload;
      const updateObj = map(state.orderVerifications, (i) => {
        if (i.id === response.id) return response;
        return i;
      });
      if (updateObj !== undefined && updateObj.length > 0) {
        return produce(state, (draft) => {
          draft.orderVerifications = updateObj;
          draft.loading = false;
        });
      }
      return produce(state, (draft) => {
        draft.orderVerifications = [response];
        draft.loading = false;
      });
    }

    case UPDATE_ORDER_VERIFICATION_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case DELETE_ORDER_VERIFICATION_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case DELETE_ORDER_VERIFICATION_SUCCESS: {
      const {orderVerification} = action.payload;

      return produce(state, (draft) => {
        const {orderVerificationsFailedDelivery} = state;
        const filteredOrderVerifications = orderVerificationsFailedDelivery.filter(
          (item) => item.id !== orderVerification
        );
        draft.orderVerificationsFailedDelivery = filteredOrderVerifications;
        draft.loading = false;
      });
    }

    case DELETE_ORDER_VERIFICATION_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case DELETE_ORDER_VERIFICATION_DUPLICATED_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case DELETE_ORDER_VERIFICATION_DUPLICATED_SUCCESS: {
      const {orderVerification} = action.payload;

      return produce(state, (draft) => {
        const {orderVerificationsDuplicate} = state;
        const filteredOrderVerifications = orderVerificationsDuplicate.filter(
          (item) => item.id !== orderVerification
        );
        draft.orderVerificationsDuplicate = filteredOrderVerifications;
        draft.loading = false;
      });
    }

    case DELETE_ORDER_VERIFICATION_DUPLICATED_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case DELETE_ORDER_VERIFICATION_HIGH_VALUE_REQUEST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case DELETE_ORDER_VERIFICATION_HIGH_VALUE_SUCCESS: {
      const {orderVerification} = action.payload;

      return produce(state, (draft) => {
        const {orderVerificationHighValue} = state;
        const filteredOrderVerifications = orderVerificationHighValue.filter(
          (item) => item.id !== orderVerification
        );
        draft.orderVerificationHighValue = filteredOrderVerifications;
        draft.loading = false;
      });
    }

    case DELETE_ORDER_VERIFICATION_HIGH_VALUE_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    case CLEAR_ORDER_VERIFICATION: {
      return produce(state, (draft) => {
        draft.orderVerification = {};
      });
    }

    default: {
      return state;
    }
  }
};

export default orderVetificationReducer;
